import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { storage, db } from '../firebaseApp';

// Unambiguous alphabet (no 0/O/1/I/l) for readable short ids.
const ID_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';

const generateShareId = () => {
    const bytes = new Uint8Array(11);
    crypto.getRandomValues(bytes);
    let id = '';
    for (let i = 0; i < bytes.length; i++) {
        id += ID_ALPHABET[bytes[i] % ID_ALPHABET.length];
    }
    return id;
};

// Uploads the map image to Storage and stores a share record in Firestore.
// Returns the short share-page URL (map-shaped.com/s/<id>) — the `/s/:id`
// React route renders it as a page, and the shareCard function serves Open
// Graph tags for it to social crawlers.
export const createSharePage = async ({ blob, title, targetUrl }) => {
    const id = generateShareId();
    const objectRef = ref(storage, 'images/' + id);
    await uploadBytes(objectRef, blob, { contentType: blob.type || 'image/png' });
    const imageUrl = await getDownloadURL(objectRef);
    await setDoc(doc(db, 'shares', id), {
        image: imageUrl,
        title,
        target: targetUrl,
        createdAt: serverTimestamp(),
    });
    return { pageUrl: `https://map-shaped.com/s/${id}` };
};
